/**
 * NOTE: Current implementation is chiefly reliant on Netlify, in that:
 * * TestVariants map to Branch names (named in github, but surfaced as a env variable via Netlify)
 * * testKey is set as an environment variable name in Netlify (https://app.netlify.com/sites/appbambee/configuration/env)
 *
 * GIVEN:
 * * Netlify has a test key (AB_TEST_NAME) set as an Environment variable AND has been rebuilt (to apply said variable)
 *
 * THEN:
 * * Bucketing and Entry events (via segment) will fire once per refresh.
 *
 */
import Analytics from '@/services/Analytics';
import {getFromLocalStorage, saveInLocalStorage} from './localStorage';

// Define the test variants
const TestVariants = {
  TEST: 'test-production',
  CONTROL: 'master',
} as const;

// Get the current A/B test name from the environment variables
const abTestName: string = process.env.AB_TEST_NAME || '';

const localStorageBucketKey = `TEST_BUCKET_${abTestName}`;
const localStorageEnterKey = `TEST_ENTER_${abTestName}`;

// Get the current branch name (test variant) from the environment variables
const branchName: string = process.env.AB_TEST_VARIANT || '';

// Check if an A/B test is running
const isTestRunning: boolean = !!abTestName;

// Check if the current branch matches the test variant
export const isTestVariant: boolean = branchName === TestVariants.TEST;

// Check if the current branch matches the control variant
export const isControlVariant: boolean = branchName === TestVariants.CONTROL;

const checkBucketingCache = () => {  
  return isTestRunning && !!getFromLocalStorage(localStorageBucketKey)
}
const checkEnterCache = () => {  
  return isTestRunning && !!getFromLocalStorage(localStorageEnterKey)
}

// Send a tracking event if the current page load is part of an A/B test and hasn't been bucketed yet
export const netlifyBucketTest = (
  additionalContext: Record<string, string> = {}
): void => {

  if (!checkBucketingCache()) {
    saveInLocalStorage(localStorageBucketKey, 'true')

    Analytics?.track(abTestName, {
      ...additionalContext,
      'test-variant': branchName,
    });
  }
};

let hasEnteredTest = false;

// Send an entry event if the current page load is part of an A/B test and hasn't entered yet
export const netlifyEnterTest = (
  additionalContext: Record<string, string> = {}
): void => {

  if (!hasEnteredTest && !checkEnterCache()) {
    saveInLocalStorage(localStorageEnterKey, 'true')

    Analytics?.track('ab-test-entry', {
      ...additionalContext,
      'test-name': abTestName,
      'test-variant': branchName,
    });
  }
};
